<!-- 
<p-floatlabel variant="on" class="tipoLancamento">
  <p-autoComplete inputId="{{ prefix }}-tipoLancamento-{{ i }}" [fluid]="true" field="nome"
     formControlName="tipoLancamento" [suggestions]="filteredTiposLancamento[i]"
    (completeMethod)="filterTiposLancamentosDropdown($event, i)" floatlabel-field="nome" [dropdown]="true"
    (onBlur)="onAutoCompleteBlur($event)" styleClass="w-full" (onFocus)="selectInputText($event)"
    (keydown)="tabToNextComponentOnAutocomplete($event, i, 'tipoLancamento')" />
  <label>Tipo de lançamento</label>
</p-floatlabel> -->

<p-floatlabel variant="on">
  <p-autoComplete
    [inputId]="inputId"
    [fluid]="true"
    [optionLabel]="displayField"
    [optionValue]="optionValueIdentity"
    [forceSelection]="true"
    [suggestions]="filtered"
    (completeMethod)="filter($event)"
    [dropdown]="true"
    (onBlur)="handleBlur($event)"
    (onFocus)="handleFocus($event)"
    (keydown)="handleKeydown($event)"
    styleClass="w-full"

    [ngModel]="value"
    (ngModelChange)="handleInputChange($event)"
    [disabled]="disabled"
    (onSelect)="handleSelect($event)"
    appendTo="body"
  />
  <label>{{label}}</label>
</p-floatlabel>
